module.exports = __webpack_public_path__ + "static/img/zhihu1.d87ac3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/zhihu1.png
// module id = QCYT
// module chunks = 1